import { FieldModel } from '@cibo/core'
import { LimingCellDisplay } from '@cibo/landmanager'
import { TraitCellContainer } from './TraitCellContainer'

interface LimingCellProps {
  value: any
  task: any
  year: number
  selectedField: FieldModel | null
}

export const LimingCell = ({ value, task, year, selectedField }: LimingCellProps) => {
  return (
    <TraitCellContainer
      value={value}
      task={task}
      selectedField={selectedField}
      year={year}
      traitId="liming"
    >
      <LimingCellDisplay value={value} />
    </TraitCellContainer>
  )
}
